const LocationSource = {
  GoogleMaps: "GOOGLE_MAPS",
  AWS: "AWS",
} as const;

type LocationSource = (typeof LocationSource)[keyof typeof LocationSource];

export default LocationSource;
export type { LocationSource };
